<template>
  <div class="h-full pt-10">
    <div class="md:container mx-auto xl:max-w-4xl grid grid-cols-12" v-if="!loading">
      <div class="col-span-4">
        <h2 class="font-bold lg:text-2xl">企业基本信息</h2>
        <p></p>
      </div>
      <div class="col-span-8">
        <basic-form ref="form1" :info="info" />
      </div>

      <div class="col-span-4 font-bold lg:text-2xl">企业属性</div>
      <div class="col-span-8">
        <attr-form ref="form2" :info="info" />
      </div>

      <div class="col-span-4 font-bold lg:text-2xl">数字化转型机构</div>
      <div class="col-span-8">
        <digitize-form ref="form3" :info="info" @save="handleUpdate" />
      </div>

      <div class="col-span-4 text-xs text-gray-400">
        <h2 class="font-bold lg:text-2xl text-black">企业营收</h2>
        <p>企业近三年营业收入与从业人员</p>
        <p class="text-red-300">请如实填写，数据会影响评测结果!</p>
      </div>
      <div class="col-span-8">
        <turnover-form :info="info" @save="handleSave" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import BasicForm from '@/views/info/partials/basic.vue'
import AttrForm from '@/views/info/partials/attr.vue'
import DigitizeForm from '@/views/info/partials/digitize.vue'
import TurnoverForm from '@/views/info/partials/turnover.vue'
import { getInfo, getRevenueBaseInfoList, updateInfo } from '@/api/enterprise'

export default {
  name: 'Home',
  components: { BasicForm, AttrForm, DigitizeForm, TurnoverForm },
  data () {
    return {
      loading: false,
      info: {}
    }
  },
  computed: {
    ...mapGetters(['staff', 'token'])
  },
  mounted () {
    this.loadInfo()
  },
  methods: {
    loadInfo () {
      this.loading = true
      return Promise.all([
        getInfo({ userId: this.staff.id }).then(res => {
          return res.data
        }),
        getRevenueBaseInfoList(this.staff.id).then(res => {
          return res.data || []
        })
      ]).then(([info, revenue]) => {
        this.info = Object.assign({}, info, { revenue: revenue.sort((a, b) => a.year * 1 > b.year * 1 ? 1 : -1) })
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleUpdate () {
      Promise.all([this.$refs.form1, this.$refs.form2, this.$refs.form3].map(v => new Promise((resolve, reject) => { v.$children[0].validate(valid => valid ? resolve() : reject(new Error('valid'))) }))).then(() => {
        const data = Object.assign({}, this.info, this.$refs.form1.form, this.$refs.form2.form, this.$refs.form3.form)
        updateInfo(data).then(() => {
          this.$message.success('保存成功')
          Object.assign(this.info, data)
        })
      }).catch(() => {})
    },
    handleSave (data) {
      Object.assign(this.info, data)
    }
  }
}
</script>

<style>
</style>
